export type ClaimRecord = { fromPoolAddress: string; investorAddress: string }
export type ClaimEventName = 'DepositClaimedEvent' | 'RedeemClaimedEvent'

const claimEvents = new EventTarget()

export const emitClaimEvent = (name: ClaimEventName, claims: readonly ClaimRecord[]): void => {
  claimEvents.dispatchEvent(new CustomEvent(name, { detail: claims }))
}

export const onClaimEvent = (name: ClaimEventName, handler: (claims: readonly ClaimRecord[]) => void): (() => void) => {
  const listener = (event: Event) => handler((event as CustomEvent<readonly ClaimRecord[]>).detail)
  claimEvents.addEventListener(name, listener)
  return () => claimEvents.removeEventListener(name, listener)
}
